import "date-fns";
import React, { useEffect, useState } from "react";
import { Box, colors, Grid, IconButton, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import {
    useStylesAuto,
    useStylesLbl,
    useStylesTF,
} from "../../St/comps/UseStyle";
import { useTranslation } from "react-i18next";
import { Search } from "@material-ui/icons";

export default function AccountSearch(props) {
    const { accounts,account, onSelect,handleIconSearchAccount,handleInputSearchAccount,searchAccountText ,name} = props;

    const [barcode, setBarcode] = useState(accounts?.id);
    const { t } = useTranslation(["forms"]);
    useEffect(() => {
        setBarcode(account?.id);
    }, [accounts]);

    const clasTF = useStylesTF();
    const clasAo = useStylesAuto();
    const claslbl = useStylesLbl();
    const handleSearch = (e) => {
        setBarcode(e.target.value);
        const result = accounts?.filter((x) => x.id == e.target.value);
        if (result.length > 0) {
            onSelect(result[0]);
        }
    };

    return (
        <React.Fragment>
            <Grid container spacing={2}>
                <Grid item lg={4} md={4} sm={4} xs={4}>
                    <TextField
                        type="number"
                        fullWidth
                        variant="outlined"
                        size="small"
                        id="accno"
                        // label={t("account-code")}
                        label={name}
                        className={clasTF.rootSale}
                        style={{ backgroundColor: colors.grey[50] }}
                        InputProps={{ className: clasTF.inputSale }}
                        name="accno"
                        value={barcode}
                        InputLabelProps={{ shrink: true }}
                        onChange={handleSearch}
                    />
                </Grid>

                <Grid item lg={8} md={8} sm={8} xs={8}>
                    <Autocomplete
                        classes={clasAo}
                        value={account}
                        labelPlacement=""
                        onInputChange={(event, newValue, reason) => {
                            if (reason === "input") handleInputSearchAccount(event, newValue, reason);
                        }}
                        onChange={(event, newValue) => {
                            setBarcode(newValue.id);
                            onSelect(newValue);
                        }}
                        id="controllable-states-demo"
                        size="small"
                        options={accounts}
                        getOptionLabel={(option) =>
                            typeof option === "string" ? option : option?.name
                        }
                        style={{ backgroundColor: colors.grey[50] }}
                        disableClearable
                        renderInput={(params) => (
                            <Box size="small" display={"flex"} textAlign={"center"}>
                                <TextField
                                    {...params}
                                    label=""
                                    variant= "outlined"
                                    fullWidth
                                    size="small"
                                    textAlign={"center"}
                                    InputLabelProps={{ className: claslbl.clrSale }}
                                />
                                {searchAccountText != "" &&
                                    (
                                        <IconButton size="small" onClick={handleIconSearchAccount}>
                                            <Search />
                                        </IconButton>
                                    )}
                            </Box>
                        )}
                    />
                </Grid>
            </Grid>
        </React.Fragment>
    );
}
